/**
 * UserData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { UserContact } from './user_contact'
import type { UserInfo } from './user_info'
import type { UserOauth } from './user_oauth'
import type { UserSetting } from './user_setting'
import type { UserStats } from './user_stats'

/**
 * UserData
 */
export interface UserData {
  /** 用户ID */
  id?: string
  /** 用户基础信息 */
  info?: UserInfo
  /** 用户统计信息 */
  stats?: UserStats
  /** 用户联系方式 */
  contact?: UserContact
  /** 用户设置信息 */
  setting?: UserSetting
  /** OAuth绑定信息 */
  oauth?: UserOauth
}

/**
 * UserData Schema
 */
export const UserDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '用户ID',
      format: 'string',
      type: 'string',
      label: '用户ID',
    },
    info: {
      $ref: 'UserInfo',
      description: '用户基础信息',
      label: '用户基础信息',
    },
    stats: {
      $ref: 'UserStats',
      description: '用户统计信息',
      label: '用户统计信息',
    },
    contact: {
      $ref: 'UserContact',
      description: '用户联系方式',
      label: '用户联系方式',
    },
    setting: {
      $ref: 'UserSetting',
      description: '用户设置信息',
      label: '用户设置信息',
    },
    oauth: {
      $ref: 'UserOauth',
      description: 'OAuth绑定信息',
      label: 'OAuth绑定信息',
    },
  },
  type: 'object',
}
